/**
 * Language model which is used in BUILDER
 */
export class CampaignLanguage{
    id?: string;
    name: string;
    flagImageUrl: string;
    shortName: string;
}
